import trigger from './trigger';

const CPF_MASK_LEN = 11;
const CNPJ_MASK_LEN = 14;

const getChildrenNode = (el) => {
  if (el.tagName === 'INPUT') return el;
  return el.querySelector('input');
};

const handlersMap = new WeakMap();

const isCpf = (raw, tipoPessoa) => {
  if (tipoPessoa === 'FISICA') return true;
  if (tipoPessoa === 'JURIDICA') return false;
  if (/[A-Z]/.test(raw)) return false;
  return raw.length <= CPF_MASK_LEN;
};

const formatCpf = raw => raw
  .substring(0, CPF_MASK_LEN)
  .replace(/^(\d{3})(\d{1,3})/, '$1.$2')
  .replace(/^(\d{3})\.(\d{3})(\d{1,3})/, '$1.$2.$3')
  .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d{1,2})/, '$1.$2.$3-$4');

const formatCnpj = (raw) => {
  const head = raw.substring(0, 12);
  const tail = raw.substring(12, CNPJ_MASK_LEN).replace(/[^0-9]/g, '');
  const cleaned = head + tail;

  return cleaned
    .replace(/^([A-Z0-9]{2})([A-Z0-9]{1,3})/, '$1.$2')
    .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9]{1,3})/, '$1.$2.$3')
    .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})([A-Z0-9]{1,4})/, '$1.$2.$3/$4')
    .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})\/([A-Z0-9]{4})(\d{1,2})/, '$1.$2.$3/$4-$5');
};

const aplicarMascaraAdaptativa = (rawInput, tipoPessoa) => {
  const raw = (rawInput || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  return isCpf(raw, tipoPessoa) ? formatCpf(raw) : formatCnpj(raw);
};

const aplicarMascara = (el, input) => {
  const tipoPessoa = (el && el.dataset && el.dataset.tipoPessoa)
    || (input && input.dataset && input.dataset.tipoPessoa)
    || null;
  const masked = aplicarMascaraAdaptativa(input.value, tipoPessoa);
  if (input.value !== masked) {
    input.value = masked;
    trigger(input, 'input');
  }
};

export const vCpfCnpj = {
  bind(el) {
    const input = getChildrenNode(el);
    if (!input) return;

    const handler = () => aplicarMascara(el, input);
    handlersMap.set(el, handler);
    input.addEventListener('input', handler);

    if (input.value) {
      aplicarMascara(el, input);
    }
  },
  update(el) {
    const input = getChildrenNode(el);
    if (!input) return;
    aplicarMascara(el, input);
  },
  unbind(el) {
    const input = getChildrenNode(el);
    const handler = handlersMap.get(el);
    if (input && handler) {
      input.removeEventListener('input', handler);
      handlersMap.delete(el);
    }
  },
};

export default vCpfCnpj;



// WEBPACK FOOTER //
// ./src/common/directives/document-masks.js